import { useQuery } from "@faire/web-api--source/api/layout/logged-out-homepage/get-hooks";
export var useBestsellerProductsQuery = function() {
    var _data_layout_elements;
    var _useQuery = useQuery({
        gcTime: Infinity,
        staleTime: Infinity
    }), data = _useQuery.data, isFetching = _useQuery.isFetching;
    return {
        bestsellerProductsElement: data === null || data === void 0 ? void 0 : (_data_layout_elements = data.layout_elements) === null || _data_layout_elements === void 0 ? void 0 : _data_layout_elements[0],
        requestId: data === null || data === void 0 ? void 0 : data.request_id,
        isFetching: isFetching
    };
};
